// client/src/modules/fleet/nav.ts
import type { NavItem } from '../types';

/**
 * Navigation items for Assets module sidebar — JTBD structure
 *
 * Organized around jobs-to-be-done: inventory management, compliance,
 * inspections, task tracking, driver management, reporting, and settings.
 */
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/assets' },
  { label: 'Assets', path: '/assets/inventory' },
  { label: 'Trucks', path: '/assets/trucks' },
  { label: 'Drivers', path: '/assets/drivers' },
  {
    label: 'Reports',
    path: '/assets/reports',
    children: [
      { label: 'Asset Reports', path: '/assets/reports' },
      { label: 'Agent Activity', path: '/assets/agent-activity' },
    ],
  },
  { label: 'Inspections', path: '/assets/forms/submissions' },
  { label: 'Settings', path: '/assets/settings', icon: 'settings' },
];
